
<template>
    <reveal-overlay :class="{ 'is-loading': loading }">
        <article class="pane">
            <header>
                <h1>{{ title }} ({{ paginator.length }})</h1>
                <input class="input" placeholder="Search" v-model="query" v-on:input="search"/>
            </header>

            <div class="content">
                <table v-if="paginator.length">
                    <tbody>
                        <tr v-for="record in paginator.results">
                            <td v-for="column in columns">{{ record[column.attribute] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <footer>
                <pagination :paginator="paginator"></pagination>
            </footer>
        </article>
    </reveal-overlay>
</template>

<script>
	import Paginator from '../../support/Paginator';
	import Search from '../../support/Search';

	export default
	{
		computed:
        {
            results()
            {
                return Search.find( this.query, this.attributes, this.records );
            },
            paginator()
            {
                return new Paginator( this.results, this.$route.query.page, this.$route.query.each );
            },
        },
		data()
		{
			return {
				loading: false,
				query: this.$route.query.search || '',
			};
		},
		methods:
        {
            search()
            {
                const query = { ...this.$route.query } || {},
                    search = this.query.trim();

                delete query.page;

                if( search !== '' ) {
                    query.search = search;
                } else delete query.search;

                this.$router.replace( { name: this.$route.name, query } )
            },
        },
		mounted()
		{
			//this.loading = true;
			//this.fetch().then( records => {
			//	this.records = records;
			//	this.loading = false;
			//});
		},
		props: {
			attributes: {
				type: Array,
                default: [],
            },
            columns: {
			    required: true,
                type: Array,
            },
			records: {
				required: true,
				type: Array,
            },
			title: {
				required: true,
                type: String,
            }
        }
	};
</script>
